export type ClassNameProp = { className?: string };

export const isSsr = () => typeof(window) === "undefined";
